webpackJsonp([14],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return TOGGLE_DEVICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TOGGLE_SIDEBAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return EXPAND_MENU; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return SWITCH_EFFECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return SET_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return SET_LOGGED_IN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return SET_UI_LOGIN_DISABLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return SET_UI_LOGIN_BTN_TEXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return SET_AUTH_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return SET_USERS_LINKED_AUTH_PROVIDERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return SET_PASSWORD_AUTH_LINKING_PENDING; });
/* unused harmony export UNLINK_AUTH_PROVIDER */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return REAUTH_REQUIRED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return REAUTH_TRIGGERED_BY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return REAUTH_INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return SET_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SET_NOTIFICATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return DISMISS_NOTIFICATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return DESTROY_NOTIFICATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_NEW_NOTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_NEW_NOTE_CONTENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ADD_NOTE; });
/* unused harmony export GET_NEW_NOTE */
/* unused harmony export GET_NOTE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return NOTES_LOADING; });
// App
var TOGGLE_DEVICE = 'TOGGLE_DEVICE';
var TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR';
var EXPAND_MENU = 'EXPAND_MENU';
var SWITCH_EFFECT = 'SWITCH_EFFECT';
// Auth
var SET_USER = 'SET_USER';
var SET_LOGGED_IN = 'SET_LOGGED_IN';
var SET_UI_LOGIN_DISABLED = 'SET_UI_LOGIN_DISABLED';
var SET_UI_LOGIN_BTN_TEXT = 'SET_UI_LOGIN_BTN_TEXT';
var SET_AUTH_PENDING = 'SET_AUTH_PENDING';
var SET_USERS_LINKED_AUTH_PROVIDERS = 'SET_USERS_LINKED_AUTH_PROVIDERS';
var SET_PASSWORD_AUTH_LINKING_PENDING = 'SET_PASSWORD_AUTH_LINKING_PENDING';
var UNLINK_AUTH_PROVIDER = 'UNLINK_AUTH_PROVIDER';
var REAUTH_REQUIRED = 'REAUTH_REQUIRED';
var REAUTH_TRIGGERED_BY = 'REAUTH_TRIGGERED_BY';
var REAUTH_INFO = 'REAUTH_INFO';
// Notices
var SET_ERROR = 'SET_ERROR';
var SET_NOTIFICATION = 'SET_NOTIFICATION';
var DISMISS_NOTIFICATION = 'DISMISS_NOTIFICATION';
var DESTROY_NOTIFICATION = 'DESTROY_NOTIFICATION';
// Notes
var SET_NEW_NOTE = 'SET_NEW_NOTE';
var SET_NEW_NOTE_CONTENTS = 'SET_NEW_NOTE_CONTENTS';
var ADD_NOTE = 'ADD_NOTE';
var GET_NEW_NOTE = 'GET_NEW_NOTE';
var GET_NOTE = 'GET_NOTE';
var NOTES_LOADING = 'NOTES_LOADING';

/***/ }),
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(104)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(90),
  /* template */
  __webpack_require__(144),
  /* scopeId */
  "data-v-1e1e6012",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_store_modules_menu__ = __webpack_require__(23);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["default"]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["default"]({
  mode: 'hash', // Demo is living in GitHub.io, so required!
  linkActiveClass: 'is-active',
  scrollBehavior: function scrollBehavior() {
    return { y: 0 };
  },
  routes: [{
    name: 'Home',
    path: '/',
    component: __webpack_require__(26)
  }, {
    name: 'Login',
    path: '/login',
    component: __webpack_require__(12)
  }, {
    name: 'Login Firebase',
    path: '/login-firebase',
    component: __webpack_require__(12)
  }].concat(_toConsumableArray(generateRoutesFromMenu(__WEBPACK_IMPORTED_MODULE_2_vuex_store_modules_menu__["a" /* default */].state.items)), [{
    path: '*',
    redirect: '/'
  }])
}));

// Menu should have 2 levels.
function generateRoutesFromMenu() {
  var menu = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var routes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  for (var i = 0, l = menu.length; i < l; i++) {
    var item = menu[i];
    if (item.path) {
      routes.push(item);
    }
    if (!item.component) {
      generateRoutesFromMenu(item.children, routes);
    }
  }
  return routes;
}

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuexfire__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuexfire___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuexfire__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_package__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_package___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_package__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__getters__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex_persistedstate__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_app__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_menu__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_auth__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modules_notes__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__modules_notifications__ = __webpack_require__(79);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




// import { firebaseAction } from 'vuexfire'




// Modules






__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["default"]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["default"].Store({
  strict: true, // process.env.NODE_ENV !== 'production',
  actions: __WEBPACK_IMPORTED_MODULE_4__actions__,
  getters: __WEBPACK_IMPORTED_MODULE_5__getters__,
  modules: {
    app: __WEBPACK_IMPORTED_MODULE_7__modules_app__["a" /* default */],
    menu: __WEBPACK_IMPORTED_MODULE_8__modules_menu__["a" /* default */],
    auth: __WEBPACK_IMPORTED_MODULE_9__modules_auth__["a" /* default */],
    notifications: __WEBPACK_IMPORTED_MODULE_11__modules_notifications__["a" /* default */],
    notes: __WEBPACK_IMPORTED_MODULE_10__modules_notes__["a" /* default */]
  },
  state: {
    pkg: __WEBPACK_IMPORTED_MODULE_3_package___default.a
  },
  plugins: [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex_persistedstate__["a" /* default */])()],
  mutations: _extends({}, __WEBPACK_IMPORTED_MODULE_2_vuexfire__["firebaseMutations"])
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mutation_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lazyLoading__ = __webpack_require__(77);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



// show: meta.label -> name
// name: component name
// meta.label: display label

var state = {
  items: [{
    name: 'User',
    path: '/user',
    meta: {
      icon: 'fa-user',
      link: 'user/index.vue',
      requiresAuth: true
    },
    component: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lazyLoading__["a" /* default */])('user', true)
  }, {
    name: 'Dashboard',
    path: '/dashboard',
    meta: {
      icon: 'fa-tachometer',
      link: 'dashboard/index.vue'
    },
    component: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lazyLoading__["a" /* default */])('dashboard', true)
  }, {
    name: 'Axios',
    path: '/axiosDemo',
    meta: {
      auth: true,
      icon: 'fa-rocket',
      link: 'axios/index.vue'
    },
    component: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lazyLoading__["a" /* default */])('axios', true)
  }]
};

var mutations = _defineProperty({}, __WEBPACK_IMPORTED_MODULE_0__mutation_types__["t" /* EXPAND_MENU */], function (state, menuItem) {
  if (menuItem.index > -1) {
    if (state.items[menuItem.index] && state.items[menuItem.index].meta) {
      state.items[menuItem.index].meta.expanded = menuItem.expanded;
    }
  } else if (menuItem.item && 'expanded' in menuItem.item.meta) {
    menuItem.item.meta.expanded = menuItem.expanded;
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations
});

/***/ }),
/* 24 */,
/* 25 */,
/* 26 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(111)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(89),
  /* template */
  __webpack_require__(154),
  /* scopeId */
  "data-v-6d1df42d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(106)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(91),
  /* template */
  __webpack_require__(147),
  /* scopeId */
  "data-v-41aedd49",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(95),
  /* template */
  __webpack_require__(146),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 29 */,
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__app__ = __webpack_require__(67);


__WEBPACK_IMPORTED_MODULE_0__app__["a" /* app */].$mount('#app');

/***/ }),
/* 31 */,
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NOTES; });
/* unused harmony export MESSAGES */
// App
var NOTES = 'notes';
var MESSAGES = 'messages';

/***/ }),
/* 33 */,
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./Home.vue": [
		26
	],
	"./auth/Login.vue": [
		173,
		11
	],
	"./auth/LoginFirebase.vue": [
		12
	],
	"./auth/UserPassForm.vue": [
		27
	],
	"./axios/index.vue": [
		174,
		1
	],
	"./dashboard/index.vue": [
		175,
		0
	],
	"./tables/Basic.vue": [
		176,
		12
	],
	"./ui/Buttons.vue": [
		177,
		10
	],
	"./ui/Form.vue": [
		178,
		5
	],
	"./ui/Icons.vue": [
		179,
		7
	],
	"./ui/Typography.vue": [
		180,
		13
	],
	"./user/LinkedAccounts.vue": [
		170,
		3
	],
	"./user/NewNoteForm.vue": [
		171,
		4
	],
	"./user/Notes.vue": [
		172,
		8
	],
	"./user/PassForm.vue": [
		168,
		9
	],
	"./user/index.vue": [
		181,
		2
	],
	"./user/modals/ReAuthenticate.vue": [
		169,
		6
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
module.exports = webpackAsyncContext;
webpackAsyncContext.id = 34;

/***/ }),
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return app; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__firebase_setup_config__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_axios__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__websanova_vue_auth__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__websanova_vue_auth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__websanova_vue_auth__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_nprogress__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_nprogress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_nprogress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex_router_sync__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__App_vue__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__App_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__App_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__router__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__filters__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__filters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__filters__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vuex_store_mutation_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vee_validate__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils__ = __webpack_require__(81);
/* unused harmony reexport router */
/* unused harmony reexport store */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
















// adding firebase to the Vue.prototype allows usage of firebase in your vue components by using this.$firebase
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$firebase = __WEBPACK_IMPORTED_MODULE_1_firebase__["initializeApp"](__WEBPACK_IMPORTED_MODULE_2__firebase_setup_config__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].router = __WEBPACK_IMPORTED_MODULE_9__router__["a" /* default */];

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_13_vee_validate__["a" /* default */], __WEBPACK_IMPORTED_MODULE_14__utils__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_3_axios___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5__websanova_vue_auth___default.a, {
  auth: {
    request: function request(req, token) {
      this.options.http._setHeaders.call(this, req, { Authorization: 'Bearer ' + token });
    },
    response: function response(res) {
      // Get Token from response body
      return res.data;
    }
  },
  http: __webpack_require__(42),
  router: __webpack_require__(43),
  loginData: { url: 'http://localhost:6789/login', fetchUser: false },
  refreshData: { enabled: false }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vue_nprogress___default.a);

// Enable devtools
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.devtools = true;

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__router__["a" /* default */]);

var nprogress = new __WEBPACK_IMPORTED_MODULE_6_vue_nprogress___default.a({ parent: '.nprogress-container' });

var state = __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].state;


__WEBPACK_IMPORTED_MODULE_9__router__["a" /* default */].beforeEach(function (route, redirect, next) {
  if (state.app.device.isMobile && state.app.sidebar.opened) {
    __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].commit(__WEBPACK_IMPORTED_MODULE_12_vuex_store_mutation_types__["a" /* TOGGLE_SIDEBAR */], false);
  }
  // Check route meta to see if it requires basic auth
  if (route.matched.some(function (record) {
    return record.meta.requiresAuth;
  })) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (!__WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].state.auth.loggedIn) {
      next({
        path: '/login-firebase',
        query: { redirect: route.fullPath }
      });
      __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].dispatch('setNotification', {
        'message': 'You are not logged in.',
        'type': 'danger'
      });
    } else {
      next();
    }
  } else {
    next(); // make sure to always call next()!
  }
});

Object.keys(__WEBPACK_IMPORTED_MODULE_11__filters__).forEach(function (key) {
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter(key, __WEBPACK_IMPORTED_MODULE_11__filters__[key]);
});

var app = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"](_extends({
  router: __WEBPACK_IMPORTED_MODULE_9__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */],
  nprogress: nprogress
}, __WEBPACK_IMPORTED_MODULE_8__App_vue___default.a));



/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Navbar__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Navbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Navbar__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Navbar___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Sidebar__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Sidebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Sidebar__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__Sidebar___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AppMain__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AppMain___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__AppMain__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__AppMain___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FooterBar__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FooterBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__FooterBar__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__FooterBar___default.a; });









/***/ }),
/* 69 */
/***/ (function(module, exports) {



/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  // Firebase Config
  apiKey: "AIzaSyCQJ3u4DEbRGr8HtW1mnOzot3u_qnGB6L4",
  authDomain: "hidro2019.firebaseapp.com",
  databaseURL: "https://hidro2019.firebaseio.com",
  projectId: "hidro2019",
  storageBucket: "hidro2019.appspot.com",
  messagingSenderId: "176344940233"
});

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toggleSidebar", function() { return toggleSidebar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toggleDevice", function() { return toggleDevice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "expandMenu", function() { return expandMenu; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "switchEffect", function() { return switchEffect; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mutation_types__ = __webpack_require__(3);


var toggleSidebar = function toggleSidebar(_ref, config) {
  var commit = _ref.commit;

  if (config instanceof Object) {
    commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["a" /* TOGGLE_SIDEBAR */], config);
  }
};

var toggleDevice = function toggleDevice(_ref2, device) {
  var commit = _ref2.commit;
  return commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["u" /* TOGGLE_DEVICE */], device);
};

var expandMenu = function expandMenu(_ref3, menuItem) {
  var commit = _ref3.commit;

  if (menuItem) {
    menuItem.expanded = menuItem.expanded || false;
    commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["t" /* EXPAND_MENU */], menuItem);
  }
};

var switchEffect = function switchEffect(_ref4, effectItem) {
  var commit = _ref4.commit;

  if (effectItem) {
    commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["v" /* SWITCH_EFFECT */], effectItem);
  }
};

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "pkg", function() { return pkg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "app", function() { return app; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "device", function() { return device; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sidebar", function() { return sidebar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "effect", function() { return effect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "menuitems", function() { return menuitems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "componententry", function() { return componententry; });
var pkg = function pkg(state) {
  return state.pkg;
};
var app = function app(state) {
  return state.app;
};
var device = function device(state) {
  return state.app.device;
};
var sidebar = function sidebar(state) {
  return state.app.sidebar;
};
var effect = function effect(state) {
  return state.app.effect;
};
var menuitems = function menuitems(state) {
  return state.menu.items;
};
var componententry = function componententry(state) {
  return state.menu.items.filter(function (c) {
    return c.meta && c.meta.label === 'Components';
  })[0];
};



/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mutation_types__ = __webpack_require__(3);
var _mutations;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var state = {
  device: {
    isMobile: false,
    isTablet: false
  },
  sidebar: {
    opened: false,
    hidden: false
  },
  effect: {
    translate3d: true
  }
};

var mutations = (_mutations = {}, _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_0__mutation_types__["u" /* TOGGLE_DEVICE */], function (state, device) {
  state.device.isMobile = device === 'mobile';
  state.device.isTablet = device === 'tablet';
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_0__mutation_types__["a" /* TOGGLE_SIDEBAR */], function (state, config) {
  if (state.device.isMobile && config.hasOwnProperty('opened')) {
    state.sidebar.opened = config.opened;
  } else {
    state.sidebar.opened = true;
  }

  if (config.hasOwnProperty('hidden')) {
    state.sidebar.hidden = config.hidden;
  }
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_0__mutation_types__["v" /* SWITCH_EFFECT */], function (state, effectItem) {
  for (var name in effectItem) {
    state.effect[name] = effectItem[name];
  }
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations
});

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "user", function() { return user; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "authProviders", function() { return authProviders; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "authStatus", function() { return authStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "authUI", function() { return authUI; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "passwordAuthLinkingPending", function() { return passwordAuthLinkingPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "reAuthRequired", function() { return reAuthRequired; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "reAuthTriggeredBy", function() { return reAuthTriggeredBy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "reAuthInfo", function() { return reAuthInfo; });
var user = function user(state) {
  return state.user;
};
var authProviders = function authProviders(state) {
  return state.user.authProviders;
};
var passwordAuthLinkingPending = function passwordAuthLinkingPending(state) {
  return state.user.authProviders.password.pending;
};
var authStatus = function authStatus(state) {
  return state.loggedIn;
};
var authUI = function authUI(state) {
  return state.UI;
};
var reAuthRequired = function reAuthRequired(state) {
  return state.UI.reAuthRequired;
};
var reAuthTriggeredBy = function reAuthTriggeredBy(state) {
  return state.reAuth.reAuthTriggeredBy;
};
var reAuthInfo = function reAuthInfo(state) {
  return state.reAuth.info;
};



/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__getters__ = __webpack_require__(74);
var _mutations;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }








var state = {
  user: {
    uid: null,
    displayName: null,
    email: null,
    roles: {},
    authProviders: {
      'google.com': {
        id: 'google.com',
        linked: false,
        pending: false
      },
      'facebook.com': {
        id: 'facebook.com',
        linked: false,
        pending: false
      },
      'github.com': {
        id: 'github.com',
        linked: false,
        pending: false
      },
      'password': {
        id: 'password',
        linked: false,
        info: '',
        pending: false
      }
    }
  },
  loggedIn: false,
  UI: {
    pending: false,
    reAuthRequired: false,
    loginBtnDisabled: false,
    loginBtnText: 'Sign in with Goggle',
    logoutButtonText: 'Logout',
    signedInMessage: 'Your signed in'
  },
  error: null,
  reAuth: {
    info: {},
    reAuthTriggeredBy: null
  },
  notification: {
    show: false,
    text: '',
    type: ''
  }
};

var mutations = (_mutations = {}, _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["i" /* SET_USER */], function (state, user) {
  if (user) {
    // Send through the bits of the user that we need.
    state.user.uid = user.uid;
    state.user.displayName = user.displayName;
    state.user.email = user.email;
  } else {
    state.user.uid = null;
    state.user.displayName = null;
    state.user.email = null;
  }
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["j" /* SET_LOGGED_IN */], function (state, isLoggedIn) {
  state.loggedIn = isLoggedIn;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["k" /* SET_UI_LOGIN_DISABLED */], function (state, loginBtnDisabled) {
  state.UI.loginBtnDisabled = loginBtnDisabled;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["l" /* SET_UI_LOGIN_BTN_TEXT */], function (state, text) {
  state.UI.loginBtnText = text;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["m" /* SET_AUTH_PENDING */], function (state, isAuthPending) {
  state.UI.pending = isAuthPending;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["n" /* SET_ERROR */], function (state, error) {
  state.error = error;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["o" /* SET_USERS_LINKED_AUTH_PROVIDERS */], function (state, provider) {
  // state.user.authProviders.push(provider)
  var providers = state.user.authProviders;
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(providers, provider.id, provider);
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["p" /* SET_PASSWORD_AUTH_LINKING_PENDING */], function (state, isPending) {
  // state.user.authProviders.push(provider)
  state.user.authProviders.password.pending = isPending;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["q" /* REAUTH_REQUIRED */], function (state, isRequired) {
  state.UI.reAuthRequired = isRequired;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["r" /* REAUTH_TRIGGERED_BY */], function (state, reAuthCause) {
  state.reAuth.reAuthTriggeredBy = reAuthCause;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["s" /* REAUTH_INFO */], function (state, info) {
  state.reAuth.info = info;
}), _mutations);

var actions = {
  signInWithPass: function signInWithPass(_ref, credentials) {
    var commit = _ref.commit,
        dispatch = _ref.dispatch,
        getters = _ref.getters;

    commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["m" /* SET_AUTH_PENDING */], true);
    var auth = __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.auth();
    var email = credentials.email;
    var pass = credentials.pass;
    // If there's no current user
    if (!__WEBPACK_IMPORTED_MODULE_2_firebase___default.a.auth().currentUser) {
      auth.signInWithEmailAndPassword(email, pass).then(function (result) {
        // Disable login button
        commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["k" /* SET_UI_LOGIN_DISABLED */], true);
        // Set logged in within auth state
        commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["j" /* SET_LOGGED_IN */], true);
        // Add the signed-in user info to state
        commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["i" /* SET_USER */], result.user);

        // Finish authing
        commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["m" /* SET_AUTH_PENDING */], false);
        commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["l" /* SET_UI_LOGIN_BTN_TEXT */], 'Logged in with Google.');
        __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].replace('/');
        // Dispatch the default notification for logging in
        dispatch('setNotification', getters.defaultNotifications.loggedInMessage);
      }).catch(function (error) {
        // Handle Errors here.
        commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["n" /* SET_ERROR */], error);
        // [START_EXCLUDE]
        if (error.code === 'auth/account-exists-with-different-credential') {
          dispatch('setNotification', getters.defaultNotifications.accountExistsDifferentWithCredential);
          // If you are using multiple auth providers on your app you should handle linking
          // the user's accounts here.
        } else if (error.code === 'auth/wrong-password') {
          console.error(error);
          dispatch('setNotification', {
            type: 'danger',
            message: error.message,
            duration: 5000
          });
        } else {
          console.log(error);
        }
        // [END_EXCLUDE]
      });
      // [END signin]
    }
  },
  reAuth: function reAuth(_ref2, providerId) {
    var commit = _ref2.commit,
        dispatch = _ref2.dispatch,
        getters = _ref2.getters;

    commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["m" /* SET_AUTH_PENDING */], true);
    var auth = __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.auth();
    var provider = {};

    if (providerId === 'google.com') {
      provider.type = new __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.auth.GoogleAuthProvider();
    } else if (providerId === 'facebook.com') {
      provider.type = new __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.auth.FacebookAuthProvider();
    } else if (providerId === 'github.com') {
      provider.type = new __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.auth.GithubAuthProvider();
    } else {
      provider.type = new __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.auth.GoogleAuthProvider();
    }

    auth.currentUser.reauthenticateWithPopup(provider.type).then(function (result) {
      // Disable login button
      commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["k" /* SET_UI_LOGIN_DISABLED */], true);
      // Set logged in within auth state
      commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["j" /* SET_LOGGED_IN */], true);
      // Add the signed-in user info to state
      commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["i" /* SET_USER */], result.user);
      // Finish authing
      commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["m" /* SET_AUTH_PENDING */], false);
      commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["q" /* REAUTH_REQUIRED */], false);

      // If reauth was triggered while trying to set password, try again now that we have re-authed the user
      if (getters.reAuthTriggeredBy === 'linkEmailAuthProvider') {
        dispatch('linkEmailAuthProvider', getters.reAuthInfo);
        commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["s" /* REAUTH_INFO */], null);
      }
      commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["r" /* REAUTH_TRIGGERED_BY */], null);
      // Dispatch the default notification for logging in
      dispatch('setNotification', getters.defaultNotifications.reAuthSuccess);
    }).catch(function (error) {
      // Handle Errors here.
      dispatch('setNotification', {
        type: 'danger',
        message: error.message,
        duration: 5000
      });
    });
  },
  linkEmailAuthProvider: function linkEmailAuthProvider(_ref3, credentials) {
    var commit = _ref3.commit,
        dispatch = _ref3.dispatch;

    commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["p" /* SET_PASSWORD_AUTH_LINKING_PENDING */], true);
    var auth = __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.auth();
    var email = credentials.email;
    var pass = credentials.pass;
    var credential = __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.auth.EmailAuthProvider.credential(email, pass);
    auth.currentUser.linkWithCredential(credential).then(function (user) {
      dispatch('setNotification', {
        type: 'success',
        message: 'Email account & password has been linked.',
        duration: 5000
      });
      var provider = {
        id: 'password',
        info: null,
        linked: true,
        pending: false
      };
      commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["p" /* SET_PASSWORD_AUTH_LINKING_PENDING */], false);
      commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["o" /* SET_USERS_LINKED_AUTH_PROVIDERS */], provider);
    }, function (error) {
      // If it's auth/requires-recent-login, prompt the user to re-authenicate
      if (error.code === 'auth/requires-recent-login') {
        dispatch('setNotification', {
          type: 'info',
          message: 'Please reauthenticate.' + error.message,
          duration: 5000
        });
        commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["q" /* REAUTH_REQUIRED */], true);
        var reAuthInfo = {};
        // Temporarily commit the email & pass to store, prior to re-authing
        reAuthInfo.email = email;
        reAuthInfo.pass = pass;
        commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["s" /* REAUTH_INFO */], reAuthInfo);
        commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["r" /* REAUTH_TRIGGERED_BY */], 'linkEmailAuthProvider');
        commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["p" /* SET_PASSWORD_AUTH_LINKING_PENDING */], false);
      } else {
        // Otherwise, set the error
        dispatch('setNotification', {
          type: 'danger',
          message: error.message,
          duration: 5000
        });
        commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["p" /* SET_PASSWORD_AUTH_LINKING_PENDING */], false);
      }
    });
  },
  linkAuthProvider: function linkAuthProvider(_ref4, providerId) {
    var commit = _ref4.commit,
        dispatch = _ref4.dispatch;

    var auth = __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.auth();
    var provider = {};

    if (providerId === 'google.com') {
      provider.type = new __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.auth.GoogleAuthProvider();
    } else if (providerId === 'facebook.com') {
      provider.type = new __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.auth.FacebookAuthProvider();
    } else if (providerId === 'github.com') {
      provider.type = new __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.auth.GithubAuthProvider();
    } else {
      provider.type = new __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.auth.GoogleAuthProvider();
    }

    auth.currentUser.linkWithPopup(provider.type).then(function (result) {
      // Accounts successfully linked.
      // var credential = result.credential
      // var user = result.user
      // ...
      dispatch('setNotification', {
        type: 'success',
        message: providerId + ' account has been linked.',
        duration: 5000
      });
      var provider = {
        id: providerId,
        info: null,
        linked: true,
        pending: false
      };
      commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["o" /* SET_USERS_LINKED_AUTH_PROVIDERS */], provider);
    }).catch(function (error) {
      // Handle Errors here.
      // ...
      dispatch('setNotification', {
        type: 'danger',
        message: error.message,
        duration: 5000
      });
    });
  },
  unlinkAuthProvider: function unlinkAuthProvider(_ref5, providerId) {
    var commit = _ref5.commit,
        dispatch = _ref5.dispatch;

    var auth = __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.auth();
    auth.currentUser.unlink(providerId).then(function () {
      var provider = {
        id: providerId,
        info: null,
        linked: false,
        pending: false
      };
      commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["o" /* SET_USERS_LINKED_AUTH_PROVIDERS */], provider);
      dispatch('setNotification', {
        type: 'warning',
        message: providerId + ' account has been unlinked.',
        duration: 5000
      });
    }).catch(function (error) {
      dispatch('setNotification', {
        type: 'danger',
        message: error.message,
        duration: 5000
      });
    });
  },
  setAuthProviders: function setAuthProviders(_ref6) {
    var commit = _ref6.commit;

    var auth = __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.auth();
    var providerData = auth.currentUser.providerData;
    for (var key in providerData) {
      if (providerData.hasOwnProperty(key)) {
        // console.log(providerData[key].providerId)
        var providerInfo = providerData[key];
        var providerId = providerData[key].providerId;
        var provider = {
          id: providerId,
          info: providerInfo,
          linked: true,
          pending: false
        };
        commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["o" /* SET_USERS_LINKED_AUTH_PROVIDERS */], provider);
      }
    }
  },
  onAuthStateNotAuthenticated: function onAuthStateNotAuthenticated(_ref7, user) {
    var commit = _ref7.commit;

    commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["i" /* SET_USER */], user);
    commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["k" /* SET_UI_LOGIN_DISABLED */], false);
    commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["m" /* SET_AUTH_PENDING */], false);
  },
  onAuthStateAuthenticated: function onAuthStateAuthenticated(_ref8, user) {
    var commit = _ref8.commit,
        dispatch = _ref8.dispatch;

    dispatch('setAuthProviders');
    if (user) {
      // User is signed in.
      // Check if the user exists in /users ref.  Returns true or false.
      var ref = __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.database().ref('users/' + user.uid).once('value');

      ref.then(function (snapshot) {
        var userIdInDatabase = snapshot.hasChild('uid'); // true
        if (userIdInDatabase) {
          console.log('User ref exists.');
          // Update firebase ref users/uid/loggedIn boolean to true
          var userRef = __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.database().ref('users/' + user.uid);
          userRef.update({ 'loggedIn': 'true' });
        } else {
          console.log('User ref does not exist. Creating...');
          // Update firebase ref users/uid/loggedIn boolean to true (this also creates the parent UID object)
          var _userRef = __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.database().ref('users/').child(user.uid);
          _userRef.update({ 'loggedIn': 'true', 'uid': user.uid }).catch(__WEBPACK_IMPORTED_MODULE_4__utils__["a" /* onReject */]).then(function () {
            console.log('User ref created.');
          });
        }
      });
    }

    commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["i" /* SET_USER */], user);
    commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["m" /* SET_AUTH_PENDING */], false);
    commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["j" /* SET_LOGGED_IN */], true);
    commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["k" /* SET_UI_LOGIN_DISABLED */], true);
    commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["l" /* SET_UI_LOGIN_BTN_TEXT */], 'Logged in with Google.');
  },
  setUser: function setUser(_ref9, user) {
    var commit = _ref9.commit,
        dispatch = _ref9.dispatch;

    commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["i" /* SET_USER */], user);
  },
  setLoggedIn: function setLoggedIn(_ref10, isLoggedIn) {
    var commit = _ref10.commit,
        dispatch = _ref10.dispatch;

    commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["j" /* SET_LOGGED_IN */], isLoggedIn);
  },
  setUIloginDisabled: function setUIloginDisabled(_ref11, loginBtnDisabled) {
    var commit = _ref11.commit,
        dispatch = _ref11.dispatch;

    commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["k" /* SET_UI_LOGIN_DISABLED */], loginBtnDisabled);
  },
  setUIloginBtnText: function setUIloginBtnText(_ref12, string) {
    var commit = _ref12.commit,
        dispatch = _ref12.dispatch;

    commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["l" /* SET_UI_LOGIN_BTN_TEXT */], string);
  },
  setAuthPending: function setAuthPending(_ref13, authPending) {
    var commit = _ref13.commit,
        dispatch = _ref13.dispatch;

    commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["m" /* SET_AUTH_PENDING */], authPending);
  },
  setError: function setError(_ref14, error) {
    var commit = _ref14.commit,
        dispatch = _ref14.dispatch;

    commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["n" /* SET_ERROR */], error);
  },
  signOut: function signOut(_ref15) {
    var getters = _ref15.getters,
        commit = _ref15.commit,
        dispatch = _ref15.dispatch,
        state = _ref15.state;

    // Update firebase ref users/uid/loggedIn boolean to false
    var userRef = __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.database().ref('users/' + getters.user.uid);
    userRef.update({ 'loggedIn': 'false' });

    // Set the auth.user state to null
    commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["i" /* SET_USER */], null);

    // Set logged in within auth state
    commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["j" /* SET_LOGGED_IN */], false);
    commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["l" /* SET_UI_LOGIN_BTN_TEXT */], 'Sign in with Google.');

    // Signout of Firebase
    __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.auth().signOut();
    __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].push('/'); // Redirect to home after logout

    // Dispatch the default notification for logging out
    dispatch('setNotification', getters.defaultNotifications.loggedOutMessage);
  },
  googleSignIn: function googleSignIn(_ref16) {
    var getters = _ref16.getters,
        commit = _ref16.commit,
        dispatch = _ref16.dispatch,
        state = _ref16.state;

    commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["m" /* SET_AUTH_PENDING */], true);

    // If there's no current user
    if (!__WEBPACK_IMPORTED_MODULE_2_firebase___default.a.auth().currentUser) {
      // [START createprovider]
      var provider = new __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.auth.GoogleAuthProvider();
      // [END createprovider]
      // [START signin]
      __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.auth().signInWithPopup(provider).then(function (result) {
        // Disable login button
        commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["k" /* SET_UI_LOGIN_DISABLED */], true);
        // Set logged in within auth state
        commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["j" /* SET_LOGGED_IN */], true);
        // Add the signed-in user info to state
        commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["i" /* SET_USER */], result.user);

        // Finish authing
        commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["m" /* SET_AUTH_PENDING */], false);
        commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["l" /* SET_UI_LOGIN_BTN_TEXT */], 'Logged in with Google.');

        // Dispatch the default notification for logging in
        dispatch('setNotification', getters.defaultNotifications.loggedInMessage);
      }).catch(function (error) {
        // Handle Errors here.
        commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["n" /* SET_ERROR */], error);
        // [START_EXCLUDE]
        if (error.code === 'auth/account-exists-with-different-credential') {
          dispatch('setNotification', getters.defaultNotifications.accountExistsDifferentWithCredential);
          // If you are using multiple auth providers on your app you should handle linking
          // the user's accounts here.
          console.error(error);
        } else {
          console.error(error);
        }
        // [END_EXCLUDE]
      });
      // [END signin]
    }
  },
  signIn: function signIn(_ref17, signInMethod) {
    var getters = _ref17.getters,
        commit = _ref17.commit,
        dispatch = _ref17.dispatch,
        state = _ref17.state;

    commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["m" /* SET_AUTH_PENDING */], true);

    // If there's no current user
    if (!__WEBPACK_IMPORTED_MODULE_2_firebase___default.a.auth().currentUser) {
      var provider = {};
      if (signInMethod === 'google') {
        provider.type = new __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.auth.GoogleAuthProvider();
      } else if (signInMethod === 'facebook') {
        provider.type = new __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.auth.FacebookAuthProvider();
      } else if (signInMethod === 'github') {
        provider.type = new __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.auth.GithubAuthProvider();
      } else {
        provider.type = new __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.auth.GoogleAuthProvider();
      }

      // [START createprovider]
      // var provider = new firebase.auth.GoogleAuthProvider()
      // [END createprovider]
      // [START signin]
      __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.auth().signInWithPopup(provider.type).then(function (result) {
        // Disable login button
        commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["k" /* SET_UI_LOGIN_DISABLED */], true);
        // Set logged in within auth state
        commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["j" /* SET_LOGGED_IN */], true);
        // Add the signed-in user info to state
        commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["i" /* SET_USER */], result.user);

        // Finish authing
        commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["m" /* SET_AUTH_PENDING */], false);
        commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["l" /* SET_UI_LOGIN_BTN_TEXT */], 'Logged in with Google.');

        // Dispatch the default notification for logging in
        dispatch('setNotification', getters.defaultNotifications.loggedInMessage);
      }).catch(function (error) {
        // Handle Errors here.
        commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["n" /* SET_ERROR */], error);
        // [START_EXCLUDE]
        if (error.code === 'auth/account-exists-with-different-credential') {
          dispatch('setNotification', getters.defaultNotifications.accountExistsDifferentWithCredential);
          // If you are using multiple auth providers on your app you should handle linking
          // the user's accounts here.
        } else if (error.code === 'auth/wrong-password') {
          console.error(error);
          dispatch('setNotification', {
            type: 'danger',
            message: error.message,
            duration: 5000
          });
        } else {
          console.log(error);
        }
        // [END_EXCLUDE]
      });
      // [END signin]
    }
  }
};
/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations,
  actions: actions,
  getters: __WEBPACK_IMPORTED_MODULE_5__getters__
});

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export checkUserExists */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return onReject; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(22);


//
//
// Functions and Helpers for auth store.

//
// Check if a user exists in the /users ref
//
var checkUserExists = function checkUserExists(userId) {
  var ref = __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.database().ref('users/' + userId);

  var checkUserId = ref.once('value').then(function (snapshot) {
    var userIdInDatabase = snapshot.hasChild('uid'); // true
    console.log(userIdInDatabase);
    if (userIdInDatabase) {
      // console.log('User Database Record:')
      // console.log(snapshot.child(userId).val())
      return true;
    } else {
      // console.log('User Database Record:')
      // console.log(snapshot.child(userId).val())
      return false;
    }
  });
  // console.log(checkUserId)
  checkUserId.then(function (result) {
    // console.log(result)
    __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].dispatch('setNotification', {
      type: 'primary',
      message: 'checkUserExists(): ' + result
    });
    return result;
  });
  // if (checkUserId) {
  //   return true
  // } else {
  //   return false
  // }
};

// Function to call if access denied.
function onReject(rejection) {
  __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].dispatch('setNotification', {
    type: 'danger',
    message: rejection.message
  });
}



/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// lazy loading Components
// https://github.com/vuejs/vue-router/blob/dev/examples/lazy-loading/app.js#L8
/* harmony default export */ __webpack_exports__["a"] = (function (name) {
  var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return function () {
    return __webpack_require__(34)("./" + name + (index ? '/index' : '') + '.vue');
  };
});

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuexfire__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuexfire___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuexfire__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__firebase_setup_ref_types__ = __webpack_require__(32);
var _mutations;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





// Firebase Setup

// Set Messages refx
var state = {
  notes: [],
  newNote: {},
  newNoteContents: {},
  UI: {
    loading: false
  }
};

var mutations = (_mutations = {}, _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["b" /* SET_NEW_NOTE_CONTENTS */], function (state, noteContents) {
  state.newNoteContents = noteContents;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["c" /* SET_NEW_NOTE */], function (state, note) {
  state.newNote = note;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["d" /* ADD_NOTE */], function (state, note) {
  state.notes.push(note);
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["e" /* NOTES_LOADING */], function (state, isLoading) {
  state.UI.loading = isLoading;
}), _mutations);

var getters = {
  newNote: function newNote(state) {
    return state.newNote;
  },
  newNoteContents: function newNoteContents(state) {
    return state.newNoteContents;
  },
  notes: function notes(state) {
    return state.notes;
  },
  loadingNotes: function loadingNotes(state) {
    return state.UI.loading;
  }
};

var actions = {
  // On change of add note input, calls GET_NOTE mutation with data from add not input
  setNoteContents: function setNoteContents(_ref, noteContents) {
    var commit = _ref.commit;

    commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["b" /* SET_NEW_NOTE_CONTENTS */], noteContents);
  },
  setNewNote: function setNewNote(_ref2, note) {
    var commit = _ref2.commit;

    commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["c" /* SET_NEW_NOTE */], note);
  },
  isLoading: function isLoading(_ref3) {
    var commit = _ref3.commit,
        state = _ref3.state;

    var notesInStore = state.notes;
    if (notesInStore === undefined || notesInStore.length === 0) {
      commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["e" /* NOTES_LOADING */], true);
    } else {
      commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["e" /* NOTES_LOADING */], false);
    }
  },
  addNote: function addNote(_ref4) {
    var commit = _ref4.commit,
        getters = _ref4.getters,
        state = _ref4.state;

    var uid = getters.user.uid;
    var userNotes = __WEBPACK_IMPORTED_MODULE_2_firebase__["database"]().ref(__WEBPACK_IMPORTED_MODULE_3__firebase_setup_ref_types__["a" /* NOTES */]).child(uid);
    // Push to firebase
    userNotes.push({
      title: state.newNote.title,
      text: state.newNoteContents,
      completed: false
    });
  },
  removeNote: function removeNote(_ref5, note) {
    var commit = _ref5.commit,
        getters = _ref5.getters;

    var uid = getters.user.uid;
    var notes = __WEBPACK_IMPORTED_MODULE_2_firebase__["database"]().ref(__WEBPACK_IMPORTED_MODULE_3__firebase_setup_ref_types__["a" /* NOTES */]).child(uid);
    notes.child(note['.key']).remove();
  },

  setNotesRef: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuexfire__["firebaseAction"])(function (_ref6, ref) {
    var bindFirebaseRef = _ref6.bindFirebaseRef,
        rootState = _ref6.rootState;

    bindFirebaseRef(__WEBPACK_IMPORTED_MODULE_3__firebase_setup_ref_types__["a" /* NOTES */], ref);
  }),
  initNotesRef: function initNotesRef(_ref7) {
    var dispatch = _ref7.dispatch,
        rootState = _ref7.rootState;
    // Init notes ref in App.vue
    dispatch('isLoading');
    // var userNotes = firebase.database().ref(refTypes.NOTES)
    // firebase.database().ref(refTypes.NOTES).orderByChild('uid').equalTo(rootState.auth.user.uid).once('value', function (snapshot) {
    //   console.log(snapshot.val())
    // })
    // var userNotes = firebase.database().ref(refTypes.NOTES)
    var userNotes = __WEBPACK_IMPORTED_MODULE_2_firebase__["database"]().ref(__WEBPACK_IMPORTED_MODULE_3__firebase_setup_ref_types__["a" /* NOTES */]).child(rootState.auth.user.uid);
    console.log(rootState.auth.user.uid);
    dispatch('setNotesRef', userNotes);
    dispatch('isLoading');
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
});

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mutation_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(80);
var _mutations;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




// State
var state = {
  items: [],
  defaultNotifications: {
    loggedInMessage: {
      id: 'loggedInMessage',
      message: 'You\'re logged in.',
      type: 'primary',
      duration: 5000
    },
    loggedOutMessage: {
      id: 'loggedInMessage',
      message: 'You\'re logged out.',
      type: 'primary',
      duration: 5000
    },
    reAuthenticated: {
      id: 'reAuthenticated',
      message: 'You have been reauthenticated.',
      type: 'primary',
      duration: 5000
    },
    reAuthSuccess: {
      id: 'reAuthSuccess',
      message: 'You have been reauthenticated.',
      type: 'primary',
      duration: 5000
    },
    accountExistsDifferentWithCredential: {
      id: 'accountExistsDifferentWithCredential',
      message: 'You have already signed up with a different auth provider for that email.',
      type: 'danger',
      duration: 5000
    }
  }

  // Mutations
};var mutations = (_mutations = {}, _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_0__mutation_types__["f" /* SET_NOTIFICATION */], function (state, notification) {
  state.items.push(notification);
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_0__mutation_types__["g" /* DISMISS_NOTIFICATION */], function (state) {
  state.show = false;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_0__mutation_types__["h" /* DESTROY_NOTIFICATION */], function (state, notification) {
  var index = state.items.indexOf(notification);
  if (index > -1) {
    state.items.splice(index, 1);
  }
}), _mutations);

// Getters
var getters = {
  notifications: function notifications(state) {
    return state.items;
  },
  defaultNotifications: function defaultNotifications(state) {
    return state.defaultNotifications;
  }

  // Actions
};var actions = {
  setNotification: function setNotification(_ref, _ref2) {
    var dispatch = _ref.dispatch,
        commit = _ref.commit;
    var message = _ref2.message,
        type = _ref2.type,
        uuid = _ref2.uuid,
        duration = _ref2.duration;

    commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["f" /* SET_NOTIFICATION */], { message: message, type: type, id: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* generateUuid */])(), duration: duration });
  },
  dismissNotification: function dismissNotification(_ref3) {
    var commit = _ref3.commit;

    commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["g" /* DISMISS_NOTIFICATION */]);
  },
  destroyNotification: function destroyNotification(_ref4, notification) {
    var commit = _ref4.commit;

    commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["h" /* DESTROY_NOTIFICATION */], notification);
  }
};

// Export
/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations,
  getters: getters,
  actions: actions
});

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return generateUuid; });
// Util - Generate UUID
var lut = [];for (var i = 0; i < 256; i++) {
  lut[i] = (i < 16 ? '0' : '') + i.toString(16);
}

var generateUuid = function generateUuid() {
  var dvals = new Uint32Array(4);
  window.crypto.getRandomValues(dvals);
  var d0 = dvals[0];
  var d1 = dvals[1];
  var d2 = dvals[2];
  var d3 = dvals[3];
  return lut[d0 & 0xff] + lut[d0 >> 8 & 0xff] + lut[d0 >> 16 & 0xff] + lut[d0 >> 24 & 0xff] + '-' + lut[d1 & 0xff] + lut[d1 >> 8 & 0xff] + '-' + lut[d1 >> 16 & 0x0f | 0x40] + lut[d1 >> 24 & 0xff] + '-' + lut[d2 & 0x3f | 0x80] + lut[d2 >> 8 & 0xff] + '-' + lut[d2 >> 16 & 0xff] + lut[d2 >> 24 & 0xff] + lut[d3 & 0xff] + lut[d3 >> 8 & 0xff] + lut[d3 >> 16 & 0xff] + lut[d3 >> 24 & 0xff];
};



/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var veeValidateConfig = {
  errorBagName: 'errors', // change if property conflicts.
  fieldsBagName: 'fields',
  delay: 0,
  locale: 'en',
  dictionary: null,
  strict: true,
  enableAutoClasses: false,
  classNames: {
    touched: 'touched', // the control has been blurred
    untouched: 'untouched', // the control hasn't been blurred
    valid: 'valid', // model is valid
    invalid: 'invalid', // model is invalid
    pristine: 'pristine', // control has not been interacted with
    dirty: 'dirty' // control has been interacted with
  },
  events: 'input|blur',
  inject: true
};

/* harmony default export */ __webpack_exports__["a"] = ({
  veeValidateConfig: veeValidateConfig
});

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_nprogress_src_NprogressContainer__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_nprogress_src_NprogressContainer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_nprogress_src_NprogressContainer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_layout___ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_ui_Notifications__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_ui_Notifications___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_ui_Notifications__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Navbar: __WEBPACK_IMPORTED_MODULE_1_components_layout___["a" /* Navbar */],
    Sidebar: __WEBPACK_IMPORTED_MODULE_1_components_layout___["b" /* Sidebar */],
    AppMain: __WEBPACK_IMPORTED_MODULE_1_components_layout___["c" /* AppMain */],
    FooterBar: __WEBPACK_IMPORTED_MODULE_1_components_layout___["d" /* FooterBar */],
    NprogressContainer: __WEBPACK_IMPORTED_MODULE_0_vue_nprogress_src_NprogressContainer___default.a,
    Notifications: __WEBPACK_IMPORTED_MODULE_2_components_ui_Notifications___default.a
  },
  beforeMount: function beforeMount() {
    var _this = this;

    var _document = document,
        body = _document.body;

    var WIDTH = 768;
    var RATIO = 3;

    var handler = function handler() {
      if (!document.hidden) {
        var rect = body.getBoundingClientRect();
        var isMobile = rect.width - RATIO < WIDTH;
        _this.toggleDevice(isMobile ? 'mobile' : 'other');
        _this.toggleSidebar({
          opened: !isMobile
        });
      }
    };

    document.addEventListener('visibilitychange', handler);
    window.addEventListener('DOMContentLoaded', handler);
    window.addEventListener('resize', handler);
  },


  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["mapGetters"])({
    sidebar: 'sidebar'
  }),

  methods: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["mapActions"])(['toggleDevice', 'toggleSidebar', 'setNotification'])
});

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Levelbar__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Levelbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Levelbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import firebase from 'firebase'



/* harmony default export */ __webpack_exports__["default"] = ({
  computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapGetters"])({
    sidebar: 'sidebar'
  }), {
    hiddenSidebarStyle: function hiddenSidebarStyle() {
      return this.sidebar.hidden ? { 'margin-left': 0 } : null;
    }
  }),
  components: {
    Levelbar: __WEBPACK_IMPORTED_MODULE_0__Levelbar___default.a
  },
  created: function created() {
    // Setup Firebase onAuthStateChanged handler
    //
    // https://firebase.google.com/docs/reference/js/firebase.auth.Auth
    // https://firebase.google.com/docs/reference/js/firebase.auth.Auth#onAuthStateChanged
    // var user = this.$store.getters.getUser;
    this.$firebase.auth().onAuthStateChanged(function (user) {
      if (user) {
        this.$store.dispatch('onAuthStateAuthenticated', user);
      } else {
        this.$store.dispatch('setUIloginDisabled', false);
        this.$store.dispatch('setUser', null);
        this.$store.dispatch('setAuthPending', false);
        // https://firebase.google.com/docs/reference/js/firebase.auth.Auth#signInAnonymously
        // firebase.auth().signInAnonymously().catch(console.error)
      }
    }.bind(this));
  }
});

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return this.$store.state.pkg;
  }
});

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_bulma_breadcrumb__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_bulma_breadcrumb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_bulma_breadcrumb__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_bulma_tooltip__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Breadcrumb: __WEBPACK_IMPORTED_MODULE_0_vue_bulma_breadcrumb___default.a,
    Tooltip: __WEBPACK_IMPORTED_MODULE_1_vue_bulma_tooltip__["a" /* default */]
  },

  data: function data() {
    return {
      list: null
    };
  },
  created: function created() {
    this.getList();
  },


  computed: {
    codelink: function codelink() {
      if (this.$route.meta && this.$route.meta.link) {
        return 'https://github.com/vue-bulma/vue-admin/blob/master/client/views/' + this.$route.meta.link;
      } else {
        return null;
      }
    },
    name: function name() {
      return this.$route.name;
    }
  },

  methods: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapActions"])(['setNotification']), {
    getList: function getList() {
      var matched = this.$route.matched.filter(function (item) {
        return item.name;
      });
      var first = matched[0];
      if (first && (first.name !== 'Home' || first.path !== '')) {
        matched = [{ name: 'Home', path: '/' }].concat(matched);
      }
      this.list = matched;
    }
  }),

  watch: {
    $route: function $route() {
      this.getList();
    }
  }
});

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_bulma_tooltip__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({

  components: {
    Tooltip: __WEBPACK_IMPORTED_MODULE_0_vue_bulma_tooltip__["a" /* default */]
  },

  props: {
    show: Boolean
  },

  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapGetters"])({
    pkginfo: 'pkg',
    sidebar: 'sidebar',
    authStatus: 'authStatus'
  }),

  methods: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapActions"])(['toggleSidebar', 'signOut']), {
    logout: function logout() {
      this.$auth.logout({
        redirect: 'Home',
        makeRequest: false
        // params: {},
        // success: function () {},
        // error: function () {},
        // etc...
      });
    }
  })
});

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_bulma_expanding__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_bulma_expanding___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_bulma_expanding__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Expanding: __WEBPACK_IMPORTED_MODULE_0_vue_bulma_expanding___default.a
  },

  props: {
    show: Boolean
  },

  data: function data() {
    return {
      isReady: false
    };
  },
  mounted: function mounted() {
    var route = this.$route;
    if (route.name) {
      this.isReady = true;
      this.shouldExpandMatchItem(route);
    }
  },


  computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapGetters"])({
    'menu': 'menuitems',
    'loggedIn': 'authStatus'
  })),

  methods: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapActions"])(['expandMenu']), {
    isExpanded: function isExpanded(item) {
      return item.meta.expanded;
    },
    toggle: function toggle(index, item) {
      this.expandMenu({
        index: index,
        expanded: !item.meta.expanded
      });
    },
    shouldExpandMatchItem: function shouldExpandMatchItem(route) {
      var matched = route.matched;
      var lastMatched = matched[matched.length - 1];
      var parent = lastMatched.parent || lastMatched;
      var isParent = parent === lastMatched;

      if (isParent) {
        var p = this.findParentFromMenu(route);
        if (p) {
          parent = p;
        }
      }

      if ('expanded' in parent.meta && !isParent) {
        this.expandMenu({
          item: parent,
          expanded: true
        });
      }
    },
    generatePath: function generatePath(item, subItem) {
      return '' + (item.component ? item.path + '/' : '') + subItem.path;
    },
    findParentFromMenu: function findParentFromMenu(route) {
      var menu = this.menu;
      for (var i = 0, l = menu.length; i < l; i++) {
        var item = menu[i];
        var k = item.children && item.children.length;
        if (k) {
          for (var j = 0; j < k; j++) {
            if (item.children[j].name === route.name) {
              return item;
            }
          }
        }
      }
    }
  }),

  watch: {
    $route: function $route(route) {
      this.isReady = true;
      this.shouldExpandMatchItem(route);
    }
  }

});

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_bulma_notification__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_bulma_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_bulma_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Notification: __WEBPACK_IMPORTED_MODULE_0_vue_bulma_notification___default.a
  },
  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapGetters"])({
    notifications: 'notifications'
  }),
  methods: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapActions"])(['destroyNotification']))
});

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return this.$store.state.pkg;
  }
});

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_bulma_tabs__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__UserPassForm__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__UserPassForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__UserPassForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Tabs: __WEBPACK_IMPORTED_MODULE_0_vue_bulma_tabs__["a" /* Tabs */],
    TabPane: __WEBPACK_IMPORTED_MODULE_0_vue_bulma_tabs__["b" /* TabPane */],
    UserPassForm: __WEBPACK_IMPORTED_MODULE_1__UserPassForm___default.a
  },
  data: function data() {
    return {
      signInProviderTabs: [{
        icon: 'lock',
        label: 'Email',
        type: 'form',
        desc: 'Sign in with your email and password.'
      }, {
        icon: 'google',
        label: 'Google',
        type: 'button',
        desc: 'Sign in with google'
      }, {
        icon: 'facebook',
        label: 'Facebook',
        type: 'button',
        desc: 'Sign in with Facebook'
      }, {
        icon: 'github',
        label: 'Gitub',
        type: 'button',
        desc: 'Sign in with Github'
      }],
      data: {
        body: {
          username: null,
          password: null
        },
        rememberMe: false
      },
      error: null
    };
  },

  methods: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapActions"])(['signIn', 'signOut'])),
  computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapGetters"])({
    authUI: 'authUI'
  }))
});

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vee_validate__ = __webpack_require__(15);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'UserPassForm',
  data: function data() {
    return {
      'email': '',
      'password': ''
    };
  },

  methods: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["mapActions"])(['signInWithPass'])),
  computed: _extends({
    credentials: function credentials() {
      return {
        'email': this.email,
        'pass': this.password
      };
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["mapGetters"])({
    'authUI': 'authUI'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vee_validate__["b" /* mapFields */])({
    'emailFlags': 'email',
    'passwordFlags': 'password'
  }))
});

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({

  props: {
    list: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    },
    separator: String
  },

  mounted: function mounted() {
    if (this.separator) {
      this.$el.style.setProperty('--separator', '"' + this.separator + '"');
    }
  },


  methods: {
    isLast: function isLast(index) {
      return index === this.list.length - 1;
    },
    showName: function showName(item) {
      return item.meta && item.meta.label || item.name;
    }
  }
});

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  methods: {
    beforeEnter: function beforeEnter(el) {
      el.classList.remove('collapse');
      el.style.display = 'block';
      el.classList.add('collapsing');
      el.style.height = el.scrollHeight + 'px';
    },
    afterEnter: function afterEnter(el) {
      el.classList.remove('collapsing');
      el.classList.add('collapse', 'in');
    },
    beforeLeave: function beforeLeave(el) {
      el.classList.add('collapsing');
      el.classList.remove('collapse', 'in');
      el.style.height = 0;
    },
    afterLeave: function afterLeave(el) {
      el.classList.remove('collapsing');
      el.classList.add('collapse');
      el.style.display = 'none';
    }
  }

});

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({

  props: {
    type: String,
    title: String,
    message: String,
    direction: {
      type: String,
      default: 'Right'
    },
    duration: {
      type: Number,
      default: 4500
    },
    container: {
      type: String,
      default: '.notifications'
    }
  },

  data: function data() {
    return {
      $_parent_: null,
      show: true
    };
  },
  created: function created() {
    var $parent = this.$parent;
    if (!$parent) {
      var parent = document.querySelector(this.container);
      if (!parent) {
        // Lazy creating `div.notifications` container.
        var className = this.container.replace('.', '');
        var Notifications = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
          name: 'Notifications',
          render: function render(h) {
            return h('div', {
              'class': _defineProperty({}, '' + className, true)
            });
          }
        });
        $parent = new Notifications().$mount();
        document.body.appendChild($parent.$el);
      } else {
        $parent = parent.__vue__;
      }
      // Hacked.
      this.$_parent_ = $parent;
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (this.$_parent_) {
      this.$_parent_.$el.appendChild(this.$el);
      this.$parent = this.$_parent_;
      delete this.$_parent_;
    }
    if (this.duration > 0) {
      this.timer = setTimeout(function () {
        return _this.close();
      }, this.duration);
    }
  },
  destroyed: function destroyed() {
    this.$el.remove();
  },


  computed: {
    transition: function transition() {
      return 'bounce-' + this.direction;
    },
    enterClass: function enterClass() {
      return 'bounceIn' + this.direction;
    },
    leaveClass: function leaveClass() {
      return 'bounceOut' + this.direction;
    }
  },

  methods: {
    closedByUser: function closedByUser() {
      this.$emit('closed-by-user');
      clearTimeout(this.timer);
      this.show = false;
    },
    close: function close() {
      this.$emit('closed-automatically');
      clearTimeout(this.timer);
      this.show = false;
    },
    afterLeave: function afterLeave() {
      this.$destroy();
    }
  }
});

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    alignment: {
      type: String,
      default: ''
    }
  },

  computed: {
    classObject: function classObject() {
      var alignment = this.alignment;

      return _defineProperty({
        'tab-list': true,
        'is-flex': true
      }, 'is-' + alignment, alignment);
    }
  }
});

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var TS = {
  'fade': {
    enterClass: 'fadeIn',
    leaveClass: 'fadeOut'
  },
  'fade-horizontal-rtl': {
    enterClass: 'fadeInRight',
    leaveClass: 'fadeOutLeft'
  },
  'fade-horizontal-ltr': {
    enterClass: 'fadeInLeft',
    leaveClass: 'fadeOutRight'
  },
  'slide-horizontal-rtl': {
    enterClass: 'slideInRight',
    leaveClass: 'slideOutLeft'
  },
  'slide-horizontal-ltr': {
    enterClass: 'slideInLeft',
    leaveClass: 'slideOutRight'
  },
  'fade-vertical-dtu': {
    enterClass: 'fadeInUp',
    leaveClass: 'fadeOutUp'
  },
  'fade-vertical-utd': {
    enterClass: 'fadeInDown',
    leaveClass: 'fadeOutDown'
  },
  'slide-vertical-dtu': {
    enterClass: 'slideInUp',
    leaveClass: 'slideOutUp'
  },
  'slide-vertical-utd': {
    enterClass: 'slideInDown',
    leaveClass: 'slideOutDown'
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    icon: String,
    selected: Boolean,
    disabled: Boolean,
    label: {
      type: String,
      required: true
    },
    mode: {
      type: String,
      default: 'out-in'
    }
  },

  data: function data() {
    return {
      realSelected: this.selected,
      transition: TS['fade']
    };
  },
  created: function created() {
    this.$parent.tabPanes.push(this);
  },
  beforeDestroy: function beforeDestroy() {
    this.$parent.tabPanes.splice(this.index, 1);
  },


  computed: {
    classObject: function classObject() {
      var realSelected = this.realSelected;

      return {
        'tab-pane': true,
        'animated': true,
        'is-active': realSelected,
        'is-deactive': !realSelected
      };
    },
    layout: function layout() {
      return this.$parent.layout;
    },
    direction: function direction() {
      if (this.layout === 'top' || this.layout === 'bottom') {
        return 'horizontal';
      } else if (this.layout === 'left' || this.layout === 'right') {
        return 'vertical';
      }
      return '';
    },
    animation: function animation() {
      return this.$parent.animation;
    },
    onlyFade: function onlyFade() {
      return this.$parent.onlyFade;
    },
    gte: function gte() {
      if (this.direction === 'vertical') {
        return 'utd';
      } else if (this.direction === 'horizontal') {
        return 'ltr';
      }
      return '';
    },
    lt: function lt() {
      if (this.direction === 'vertical') {
        return 'dtu';
      } else if (this.direction === 'horizontal') {
        return 'rtl';
      }
      return '';
    },
    hidden: function hidden() {
      return this.realSelected ? 'false' : 'true';
    },
    index: function index() {
      return this.$parent.tabPanes.indexOf(this);
    }
  },

  watch: {
    '$parent.realSelectedIndex': function $parentRealSelectedIndex(index, prevIndex) {
      if (!this.onlyFade) {
        var transition = void 0;
        if (prevIndex === -1 || prevIndex > index) {
          transition = '' + this.animation + (this.layout ? '-' + this.direction : '') + (this.gte ? '-' + this.gte : '');
        } else {
          transition = '' + this.animation + (this.layout ? '-' + this.direction : '') + (this.lt ? '-' + this.lt : '');
        }
        this.transition = TS[transition] || TS['fade'];
      }
      this.realSelected = this.index === index;
    }
  }
});

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TabList__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TabList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__TabList__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    TabList: __WEBPACK_IMPORTED_MODULE_0__TabList___default.a
  },

  props: {
    isFullwidth: Boolean,
    layout: {
      type: String,
      default: 'top',
      validator: function validator(val) {
        return ['top', 'bottom', 'left', 'right'].indexOf(val) > -1;
      }
    },
    type: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: ''
    },
    alignment: {
      type: String,
      default: ''
    },
    selectedIndex: {
      type: Number,
      default: -1
    },
    animation: {
      type: String,
      default: 'fade'
    },
    onlyFade: {
      type: Boolean,
      default: true
    }
  },

  data: function data() {
    return {
      realSelectedIndex: this.selectedIndex,
      tabPanes: []
    };
  },
  mounted: function mounted() {
    this.update();
    if (this.realSelectedIndex === -1) {
      this.select(0);
    }
  },


  methods: {
    update: function update() {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.tabPanes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var tabPane = _step.value;

          if (!tabPane.disabled && tabPane.realSelected) {
            this.select(tabPane.index);
            break;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    isActived: function isActived(index) {
      return index === this.realSelectedIndex;
    },
    select: function select(index) {
      this.$emit('tab-selected', index);
      this.realSelectedIndex = index;
    }
  },
  watch: {
    selectedIndex: function selectedIndex(newIndex) {
      this.select(newIndex);
    }
  }
});

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'nprogress-container'
});

/***/ }),
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 103 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 104 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 105 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 106 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 107 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 108 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 109 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 110 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 111 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 112 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 113 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 114 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 115 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 116 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 128 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PCEtLSBCeSBTYW0gSGVyYmVydCAoQHNoZXJiKSwgZm9yIGV2ZXJ5b25lLiBNb3JlIEAgaHR0cDovL2dvby5nbC83QUp6YkwgLS0+Cjxzdmcgd2lkdGg9IjQ0IiBoZWlnaHQ9IjQ0IiB2aWV3Qm94PSIwIDAgNDQgNDQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgc3Ryb2tlPSIjMDBkMWIyIj4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgc3Ryb2tlLXdpZHRoPSIyIj4KICAgICAgICA8Y2lyY2xlIGN4PSIyMiIgY3k9IjIyIiByPSIxIj4KICAgICAgICAgICAgPGFuaW1hdGUgYXR0cmlidXRlTmFtZT0iciIKICAgICAgICAgICAgICAgIGJlZ2luPSIwcyIgZHVyPSIxLjhzIgogICAgICAgICAgICAgICAgdmFsdWVzPSIxOyAyMCIKICAgICAgICAgICAgICAgIGNhbGNNb2RlPSJzcGxpbmUiCiAgICAgICAgICAgICAgICBrZXlUaW1lcz0iMDsgMSIKICAgICAgICAgICAgICAgIGtleVNwbGluZXM9IjAuMTY1LCAwLjg0LCAwLjQ0LCAxIgogICAgICAgICAgICAgICAgcmVwZWF0Q291bnQ9ImluZGVmaW5pdGUiIC8+CiAgICAgICAgICAgIDxhbmltYXRlIGF0dHJpYnV0ZU5hbWU9InN0cm9rZS1vcGFjaXR5IgogICAgICAgICAgICAgICAgYmVnaW49IjBzIiBkdXI9IjEuOHMiCiAgICAgICAgICAgICAgICB2YWx1ZXM9IjE7IDAiCiAgICAgICAgICAgICAgICBjYWxjTW9kZT0ic3BsaW5lIgogICAgICAgICAgICAgICAga2V5VGltZXM9IjA7IDEiCiAgICAgICAgICAgICAgICBrZXlTcGxpbmVzPSIwLjMsIDAuNjEsIDAuMzU1LCAxIgogICAgICAgICAgICAgICAgcmVwZWF0Q291bnQ9ImluZGVmaW5pdGUiIC8+CiAgICAgICAgPC9jaXJjbGU+CiAgICAgICAgPGNpcmNsZSBjeD0iMjIiIGN5PSIyMiIgcj0iMSI+CiAgICAgICAgICAgIDxhbmltYXRlIGF0dHJpYnV0ZU5hbWU9InIiCiAgICAgICAgICAgICAgICBiZWdpbj0iLTAuOXMiIGR1cj0iMS44cyIKICAgICAgICAgICAgICAgIHZhbHVlcz0iMTsgMjAiCiAgICAgICAgICAgICAgICBjYWxjTW9kZT0ic3BsaW5lIgogICAgICAgICAgICAgICAga2V5VGltZXM9IjA7IDEiCiAgICAgICAgICAgICAgICBrZXlTcGxpbmVzPSIwLjE2NSwgMC44NCwgMC40NCwgMSIKICAgICAgICAgICAgICAgIHJlcGVhdENvdW50PSJpbmRlZmluaXRlIiAvPgogICAgICAgICAgICA8YW5pbWF0ZSBhdHRyaWJ1dGVOYW1lPSJzdHJva2Utb3BhY2l0eSIKICAgICAgICAgICAgICAgIGJlZ2luPSItMC45cyIgZHVyPSIxLjhzIgogICAgICAgICAgICAgICAgdmFsdWVzPSIxOyAwIgogICAgICAgICAgICAgICAgY2FsY01vZGU9InNwbGluZSIKICAgICAgICAgICAgICAgIGtleVRpbWVzPSIwOyAxIgogICAgICAgICAgICAgICAga2V5U3BsaW5lcz0iMC4zLCAwLjYxLCAwLjM1NSwgMSIKICAgICAgICAgICAgICAgIHJlcGVhdENvdW50PSJpbmRlZmluaXRlIiAvPgogICAgICAgIDwvY2lyY2xlPgogICAgPC9nPgo8L3N2Zz4="

/***/ }),
/* 129 */,
/* 130 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(109)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(82),
  /* template */
  __webpack_require__(152),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(114)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(83),
  /* template */
  __webpack_require__(157),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(105)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(84),
  /* template */
  __webpack_require__(145),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(85),
  /* template */
  __webpack_require__(151),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(107)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(86),
  /* template */
  __webpack_require__(149),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(108)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(87),
  /* template */
  __webpack_require__(150),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(103)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(88),
  /* template */
  __webpack_require__(143),
  /* scopeId */
  "data-v-1cd5d109",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(110)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(92),
  /* template */
  __webpack_require__(153),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(113)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(93),
  /* template */
  __webpack_require__(156),
  /* scopeId */
  "data-v-b9d574de",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(116)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(94),
  /* template */
  __webpack_require__(159),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(96),
  /* template */
  __webpack_require__(148),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(112)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(97),
  /* template */
  __webpack_require__(155),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(115)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(98),
  /* template */
  __webpack_require__(158),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 143 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notifications"
  }, [_c('transition-group', {
    attrs: {
      "name": "notifications",
      "tag": "div"
    }
  }, _vm._l((_vm.notifications), function(item, index) {
    return _c('notification', {
      key: item.id,
      staticClass: "notification-item",
      attrs: {
        "index": index,
        "type": item.type,
        "message": item.message,
        "container": '.notifications',
        "direction": 'right',
        "duration": item.duration,
        "id": item.id
      },
      on: {
        "closed-by-user": function($event) {
          return _vm.destroyNotification(item)
        },
        "closed-automatically": function($event) {
          return _vm.destroyNotification(item)
        }
      }
    })
  }), 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 144 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content has-text-centered"
  }, [_c('h1', {
    staticClass: "is-title is-bold"
  }, [_vm._v("Login")]), _vm._v(" "), _c('div', {
    staticClass: "columns is-vcentered"
  }, [_c('div', {
    staticClass: "column is-6 is-offset-3"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.error),
      expression: "error"
    }],
    staticStyle: {
      "color": "red",
      "word-wrap": "break-word"
    }
  }, [_vm._v(_vm._s(_vm.error))]), _vm._v(" "), (this.$store.state.auth.loggedIn) ? _c('div', {
    staticClass: "loggedInAnimation"
  }) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v("Sign in with any of your linked accounts")]), _vm._v(" "), _c('tabs', {
    attrs: {
      "layout": "left",
      "animation": "fade",
      "only-fade": false
    }
  }, _vm._l((_vm.signInProviderTabs), function(item) {
    return _c('tab-pane', {
      key: item.label,
      staticClass: "signInTabPane",
      attrs: {
        "label": item.label,
        "icon": 'fa fa-' + item.icon
      }
    }, [_c('div', {
      staticClass: "padded-box"
    }, [_c('div', {
      staticClass: "card"
    }, [_c('div', {
      staticClass: "card-header"
    }, [_c('transition', {
      attrs: {
        "name": "scaleFade",
        "mode": "out-in"
      }
    }, [(!_vm.authUI.loginBtnDisabled) ? _c('p', {
      staticClass: "card-header-title"
    }, [_vm._v(_vm._s(item.desc))]) : _vm._e()]), _vm._v(" "), _c('transition', {
      attrs: {
        "name": "scaleFade",
        "mode": "out-in"
      }
    }, [(_vm.authUI.loginBtnDisabled) ? _c('p', {
      staticClass: "card-header-title"
    }, [_vm._v("You're signed in.")]) : _vm._e()])], 1), _vm._v(" "), _c('transition', {
      attrs: {
        "name": "scaleFade",
        "mode": "out-in",
        "appear": ""
      }
    }, [(item.type === 'form' && !_vm.authUI.loginBtnDisabled) ? _c('div', {
      staticClass: "card-content"
    }, [_c('user-pass-form')], 1) : _vm._e()]), _vm._v(" "), (item.type === 'button' && !_vm.authUI.loginBtnDisabled) ? _c('div', {
      staticClass: "card-footer"
    }, [_c('a', {
      staticClass: "card-footer-item",
      class: {
        'is-loading': _vm.authUI.pending
      },
      attrs: {
        "disabled": _vm.authUI.loginBtnDisabled,
        "id": "quickstart-sign-in"
      },
      on: {
        "click": function($event) {
          return _vm.signIn(item.icon)
        }
      }
    }, [_c('i', {
      class: 'fa fa-pull-left fa-' + item.icon
    }), _vm._v(" Sign in\n                    ")])]) : _vm._e()], 1)])])
  }), 1)], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 145 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "content has-text-centered"
  }, [_c('p', [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-code"
  })]), _vm._v(" with "), _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-heart"
  })]), _vm._v(" by "), _c('a', {
    attrs: {
      "href": "https://github.com/hecz0r"
    }
  }, [_vm._v("Said Sakuh")]), _vm._v(".")])])])])
}]}

/***/ }),
/* 146 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    class: _vm.classObject,
    attrs: {
      "role": "tablist"
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 147 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    attrs: {
      "method": "post",
      "action": "/login",
      "id": "login",
      "autocomplete": "on"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('p', {
    staticClass: "has-icon has-icon-right",
    class: {
      'control': true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    class: {
      'input': true,
      'is-danger': _vm.errors.has('email'),
        'is-success': _vm.emailFlags.dirty && !_vm.errors.has('email')
    },
    attrs: {
      "id": "email",
      "name": "email",
      "type": "email",
      "placeholder": "Email",
      "autocomplete": "email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('email')),
      expression: "errors.has('email')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('email')))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('email')),
      expression: "errors.has('email')"
    }],
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-warning"
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.emailFlags.dirty && !_vm.errors.has('email')),
      expression: "emailFlags.dirty && !errors.has('email')"
    }],
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-check"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    attrs: {
      "for": "password"
    }
  }, [_vm._v("Password")]), _vm._v(" "), _c('p', {
    staticClass: "control has-icon has-icon-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:8'),
      expression: "'required|min:8'"
    }],
    class: {
      'input': true, 'is-danger': _vm.errors.has('password')
    },
    attrs: {
      "name": "password",
      "id": "password",
      "autocomplete": "password",
      "type": "password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('password')),
      expression: "errors.has('password')"
    }],
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-warning"
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('password')),
      expression: "errors.has('password')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('password')))])])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('p', {
    staticClass: "control"
  }, [_c('input', {
    staticClass: "button is-primary",
    class: {
      'is-loading': _vm.authUI.pending
    },
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        return _vm.signInWithPass(_vm.credentials)
      }
    }
  })])])])
},staticRenderFns: []}

/***/ }),
/* 148 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": _vm.animation,
      "mode": "out-in",
      "appear": "",
      "appear-active-class": _vm.transition.enterClass,
      "enter-active-class": _vm.transition.enterClass,
      "leave-active-class": _vm.transition.leaveClass
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.realSelected),
      expression: "realSelected"
    }],
    class: _vm.classObject,
    attrs: {
      "role": "tabpanel",
      "aria-labelledby": _vm.label,
      "aria-hidden": _vm.hidden
    }
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero is-bold app-navbar animated",
    class: {
      slideInDown: _vm.show, slideOutDown: !_vm.show
    }
  }, [_c('div', {
    staticClass: "hero-head"
  }, [_c('nav', {
    staticClass: "nav"
  }, [_c('div', {
    staticClass: "nav-left"
  }, [_c('a', {
    staticClass: "nav-item is-hidden-tablet",
    on: {
      "click": function($event) {
        return _vm.toggleSidebar({
          opened: !_vm.sidebar.opened
        })
      }
    }
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.sidebar.hidden),
      expression: "!sidebar.hidden"
    }],
    staticClass: "fa fa-bars",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "nav-center"
  }, [_c('transition', {
    attrs: {
      "name": "scaleFade",
      "mode": "out-in"
    }
  }, [(_vm.authStatus) ? _c('a', {
    staticClass: "nav-item hero-brand",
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(128)
    }
  }), _vm._v("\n              "), _c('strong', [_vm._v("hidro")]), _vm._v(" Admin\n          ")]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "scaleFade"
    }
  }, [(!_vm.authStatus) ? _c('a', {
    staticClass: "nav-item hero-brand",
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(127),
      "alt": _vm.pkginfo.description
    }
  }), _vm._v(" "), _c('tooltip', {
    attrs: {
      "label": 'v' + _vm.pkginfo.version,
      "placement": "right",
      "type": "success",
      "size": "small",
      "no-animate": true,
      "always": true,
      "rounded": true
    }
  }, [_c('div', {
    staticClass: "is-hidden-mobile"
  }, [_c('span', {
    staticClass: "vue"
  }, [_vm._v("hidro")]), _c('strong', {
    staticClass: "admin"
  }, [_vm._v("Admin")])])])], 1) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "nav-right is-flex"
  }, [(!this.$store.state.auth.loggedIn) ? _c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "to": "/login-firebase"
    }
  }, [_vm._v("Login Firebase")]) : _vm._e(), _vm._v(" "), (this.$store.state.auth.loggedIn) ? _c('a', {
    staticClass: "nav-item",
    on: {
      "click": _vm.signOut
    }
  }, [_vm._v("Logout")]) : _vm._e()], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 150 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "menu app-sidebar animated",
    class: {
      slideInLeft: _vm.show, slideOutLeft: !_vm.show
    }
  }, [_c('p', {
    staticClass: "menu-label"
  }, [(_vm.loggedIn) ? _c('i', {
    staticClass: "fa fa-lock fa-lg"
  }) : _vm._e(), _vm._v(" General\n  ")]), _vm._v(" "), _c('ul', {
    staticClass: "menu-list"
  }, _vm._l((_vm.menu), function(item, index) {
    return _c('li', [(item.path && item.meta.requiresAuth !== true) ? _c('router-link', {
      attrs: {
        "to": item.path,
        "exact": true,
        "aria-expanded": _vm.isExpanded(item) ? 'true' : 'false'
      },
      nativeOn: {
        "click": function($event) {
          return _vm.toggle(index, item)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      class: ['fa', item.meta.icon]
    })]), _vm._v("\n        " + _vm._s(item.meta.label || item.name) + "\n        "), (item.children && item.children.length) ? _c('span', {
      staticClass: "icon is-small is-angle"
    }, [_c('i', {
      staticClass: "fa fa-angle-down"
    })]) : _vm._e()]) : (item.path && item.meta.requiresAuth === true && _vm.loggedIn === true) ? _c('router-link', {
      attrs: {
        "to": item.path,
        "exact": true,
        "aria-expanded": _vm.isExpanded(item) ? 'true' : 'false'
      },
      nativeOn: {
        "click": function($event) {
          return _vm.toggle(index, item)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      class: ['fa', item.meta.icon]
    })]), _vm._v("\n        " + _vm._s(item.meta.label || item.name) + "\n        "), (item.children && item.children.length) ? _c('span', {
      staticClass: "icon is-small is-angle"
    }, [_c('i', {
      staticClass: "fa fa-angle-down"
    })]) : _vm._e()]) : (item.meta.requiresAuth === true && _vm.loggedIn === true) ? _c('a', {
      attrs: {
        "aria-expanded": _vm.isExpanded(item)
      },
      on: {
        "click": function($event) {
          return _vm.toggle(index, item)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      class: ['fa', item.meta.icon]
    })]), _vm._v("\n        " + _vm._s(item.meta.label || item.name) + "\n        "), (item.children && item.children.length) ? _c('span', {
      staticClass: "icon is-small is-angle"
    }, [_c('i', {
      staticClass: "fa fa-angle-down"
    })]) : _vm._e()]) : (item.meta.requiresAuth === null) ? _c('a', {
      attrs: {
        "aria-expanded": _vm.isExpanded(item)
      },
      on: {
        "click": function($event) {
          return _vm.toggle(index, item)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      class: ['fa', item.meta.icon]
    })]), _vm._v("\n        " + _vm._s(item.meta.label || item.name) + "\n        "), (item.children && item.children.length) ? _c('span', {
      staticClass: "icon is-small is-angle"
    }, [_c('i', {
      staticClass: "fa fa-angle-down"
    })]) : _vm._e()]) : _vm._e(), _vm._v(" "), (item.children && item.children.length) ? _c('expanding', [_c('ul', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isExpanded(item)),
        expression: "isExpanded(item)"
      }]
    }, _vm._l((item.children), function(subItem) {
      return (subItem.path) ? _c('li', [_c('router-link', {
        attrs: {
          "to": _vm.generatePath(item, subItem)
        }
      }, [_vm._v("\n              " + _vm._s(subItem.meta && subItem.meta.label || subItem.name) + "\n            ")])], 1) : _vm._e()
    }), 0)]) : _vm._e()], 1)
  }), 0)])
},staticRenderFns: []}

/***/ }),
/* 151 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "level app-levelbar"
  }, [_c('div', {
    staticClass: "level-left"
  }, [_c('div', {
    staticClass: "level-item"
  }, [_c('h3', {
    staticClass: "subtitle is-5"
  }, [_c('strong', [_vm._v(_vm._s(_vm.name))])])]), _vm._v(" "), (!!_vm.codelink) ? _c('div', {
    staticClass: "level-item"
  }, [_c('tooltip', {
    attrs: {
      "label": "View code",
      "placement": "right",
      "size": "small",
      "rounded": true
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('a', {
    attrs: {
      "href": _vm.codelink
    }
  }, [_c('i', {
    staticClass: "fa fa-github"
  })])])])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "level-right is-hidden-mobile"
  }, [_c('breadcrumb', {
    attrs: {
      "list": _vm.list
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 152 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('nprogress-container'), _vm._v(" "), _c('navbar', {
    attrs: {
      "show": true
    }
  }), _vm._v(" "), _c('sidebar', {
    attrs: {
      "show": _vm.sidebar.opened && !_vm.sidebar.hidden
    }
  }), _vm._v(" "), _c('app-main'), _vm._v(" "), _c('footer-bar'), _vm._v(" "), _c('notifications')], 1)
},staticRenderFns: []}

/***/ }),
/* 153 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', {
    staticClass: "breadcrumb"
  }, _vm._l((_vm.list), function(item, index) {
    return _c('li', [(_vm.isLast(index)) ? _c('span', {
      staticClass: "active"
    }, [_vm._v(_vm._s(_vm.showName(item)))]) : _c('router-link', {
      attrs: {
        "to": item.path
      }
    }, [_vm._v(_vm._s(_vm.showName(item)))])], 1)
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 154 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content has-text-centered"
  }, [_c('h1', {
    staticClass: "is-title is-bold"
  }, [_vm._v("HidroAdmin")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Trofeul Hidrotehnicii 2019")]), _vm._v(",\n    "), _c('a', {
    attrs: {
      "href": _vm.homepage
    }
  }, [_vm._v("Demo Live")])])])
},staticRenderFns: []}

/***/ }),
/* 155 */
/***/ (function(module, exports) {

module.exports={render:function (){
var _obj, _obj$1;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ( _obj = {
      'vue-bulma-tabs': true
    }, _obj[("is-layout-" + _vm.layout)] = true, _obj )
  }, [_c('div', {
    class: ( _obj$1 = {
      tabs: true
    }, _obj$1[("is-" + _vm.size)] = _vm.size, _obj$1[("is-" + _vm.alignment)] = _vm.alignment, _obj$1[("is-" + _vm.type)] = _vm.type, _obj$1['is-fullwidth'] =  _vm.isFullwidth, _obj$1 )
  }, [_vm._t("left-tab-list"), _vm._v(" "), _c('tab-list', _vm._l((_vm.tabPanes), function(tab, index) {
    return _c('li', {
      class: {
        'is-active': _vm.isActived(index), 'is-disabled': tab.disabled, 'is-flex': true
      },
      attrs: {
        "role": "tab",
        "aria-selected": _vm.isActived(index) ? 'true' : 'false',
        "aria-expanded": _vm.isActived(index) ? 'true' : 'false',
        "aria-disabled": tab.disabled ? 'true' : 'false',
        "selected": _vm.isActived(index),
        "disabled": tab.disabled
      },
      on: {
        "click": function($event) {
          return _vm.select(index)
        }
      }
    }, [_c('a', {
      staticClass: "is-unselectable"
    }, [(tab.icon) ? _c('span', {
      class: ['icon', {
        'is-small': _vm.size !== 'large'
      }]
    }, [_c('i', {
      class: tab.icon
    })]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(tab.label))])])])
  }), 0), _vm._v(" "), _vm._t("right-tab-list")], 2), _vm._v(" "), _c('div', {
    staticClass: "tab-content is-flex"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),
/* 156 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    on: {
      "beforeEnter": _vm.beforeEnter,
      "afterEnter": _vm.afterEnter,
      "beforeLeave": _vm.beforeLeave,
      "afterLeave": _vm.afterLeave
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 157 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "app-main",
    style: ([_vm.hiddenSidebarStyle])
  }, [_c('div', {
    staticClass: "container is-fluid is-marginless app-content"
  }, [_c('levelbar'), _vm._v(" "), _c('transition', {
    attrs: {
      "mode": "out-in",
      "enter-active-class": "fadeIn",
      "leave-active-class": "fadeOut",
      "appear": ""
    }
  }, [_c('router-view', {
    staticClass: "animated"
  })], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 158 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nprogress-container"
  })
},staticRenderFns: []}

/***/ }),
/* 159 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": _vm.transition,
      "mode": "in-out",
      "appear": "",
      "appear-active-class": _vm.enterClass,
      "enter-active-class": _vm.enterClass,
      "leave-active-class": _vm.leaveClass
    },
    on: {
      "after-leave": _vm.afterLeave
    }
  }, [(_vm.show) ? _c('div', {
    class: ['notification', 'animated', _vm.type ? ("is-" + _vm.type) : '']
  }, [_c('button', {
    staticClass: "delete touchable",
    on: {
      "click": function($event) {
        return _vm.closedByUser()
      }
    }
  }), _vm._v(" "), (_vm.title) ? _c('div', {
    staticClass: "title is-5"
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm._v("\n    " + _vm._s(_vm.message) + "\n  ")]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */
/***/ (function(module, exports) {

module.exports = {"name":"vuexfire-admin","version":"0.0.01","description":"HidroAdmin","repository":"vue-bulma/vuexfire-admin","homepage":"https://github.com/vue-bulma/vuexfire-admin","license":"MIT","author":{"name":"Said Sakuh","email":"said@sakuh.me","url":"said.sakuh.me"},"keywords":["admin","bulma","dashboard","data","visualization","vue","firebase","vuexfire","vue-admin","vuexfire-admin","vue-bulma"],"engines":{"node":">=4","npm":">=3"},"scripts":{"build":"cross-env NODE_ENV=production node build/build.js","clean":"rm -rf dist","dev":"cross-env NODE_ENV=development node build/dev-server.js","electron":"cross-env NODE_ELECTRON=true npm run build && electron electronIndex.js","gh":"npm run build && gh-pages -d dist","lint":"eslint --ext .js .vue client/*","lint:fix":"eslint --fix --ext .js .vue electron.js client/* build/* config/*","test":"echo lol","start":"node server.js"},"dependencies":{"@websanova/vue-auth":"^2.8.2-beta","animate.css":"3.5.2","animejs":"^2.0.1","axios":"^0.15.3","bulma":"^0.5.3","express":"^4.16.4","firebase":"^4.1.3","font-awesome":"4.7.0","mdi":"^1.8.36","quill-delta-to-html":"^0.3.0","vee-validate":"^2.0.0-rc.13","vue":"^2.2.2","vue-axios":"^2.0.1","vue-bulma-brace":"^0.1.0","vue-bulma-breadcrumb":"^1.0.1","vue-bulma-card":"^1.0.2","vue-bulma-chartjs":"^1.0.5","vue-bulma-collapse":"1.0.3","vue-bulma-datepicker":"^1.3.0","vue-bulma-emoji":"^0.0.2","vue-bulma-expanding":"^0.0.1","vue-bulma-jump":"^0.0.2","vue-bulma-message":"^1.1.1","vue-bulma-modal":"1.0.1","vue-bulma-notification":"^1.1.1","vue-bulma-progress-bar":"^1.0.2","vue-bulma-progress-tracker":"0.0.4","vue-bulma-quill":"0.0.1","vue-bulma-rating":"^1.0.1","vue-bulma-slider":"^1.0.2","vue-bulma-switch":"^1.0.4","vue-bulma-tabs":"^1.1.2","vue-bulma-tooltip":"^1.0.3","vue-cleave":"1.1.1","vue-lory":"0.0.4","vue-nprogress":"0.1.5","vue-router":"^2.3.0","vuex":"^2.2.1","vuex-persistedstate":"^2.0.0","vuex-router-sync":"^4.1.2","vuexfire":"^2.1.3","wysiwyg.css":"0.0.2"},"devDependencies":{"autoprefixer":"^6.7.7","babel-core":"^6.21.0","babel-eslint":"^7.1.1","babel-loader":"^6.4.0","babel-plugin-transform-export-extensions":"^6.8.0","babel-preset-es2015":"^6.14.0","babel-preset-stage-2":"^6.17.0","connect-history-api-fallback":"^1.3.0","cross-env":"^3.1.3","css-loader":"^0.27.1","electron-devtools-installer":"^2.0.1","eslint":"^3.17.1","eslint-config-standard":"^7.0.1","eslint-friendly-formatter":"^2.0.7","eslint-loader":"^1.6.1","eslint-plugin-html":"^2.0.1","eslint-plugin-promise":"^3.5.0","eslint-plugin-standard":"^2.1.1","eventsource-polyfill":"^0.9.6","express":"^4.15.2","extract-text-webpack-plugin":"^2.0.0-beta.4","file-loader":"^0.10.1","html-webpack-plugin":"^2.25.0","http-proxy-middleware":"^0.17.4","imports-loader":"^0.7.0","node-sass":"^4.1.1","opn":"^4.0.2","ora":"^1.1.0","postcss-loader":"^1.3.3","progress-bar-webpack-plugin":"^1.9.1","sass-loader":"^6.0.3","serve-favicon":"^2.4.1","style-loader":"^0.13.1","stylus":"^0.54.5","stylus-loader":"^3.0.1","url-loader":"^0.5.7","vue-html-loader":"^1.2.3","vue-loader":"^11.1.4","vue-template-compiler":"^2.2.2","webpack":"^2.2.1","webpack-dev-middleware":"^1.9.0","webpack-hot-middleware":"^2.14.0","webpack-merge":"^4.0.0"}}

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(30);


/***/ })
],[164]);


// WEBPACK FOOTER //
// assets/js/app.96d057c1f8dcaec7468c.js